// public/js/features/assets/stand-models.js
// Which engine stand types we hold a 3D model for.
//
// Same shape and the same reasoning as branded-models.js for device images: the
// set of models is platform content that changes when WE add a file, so it is a
// compile-time fact rather than a lookup. Listing it here means the asset detail
// page knows whether to render the viewer at all, without a round-trip that ends
// in a 404 and a flash of empty panel.
//
// The key is the `engineStandType` value from the asset-field registry and is
// also the S3 object name: models/engine-stand/<key>.glb in the asset-files
// bucket, fetched through /api/v1/asset-models/<key>/url (authenticated, short
// lived signature — never a public path).

export const STAND_MODELS = {
  'CFM56-7B': { label: 'CFM56-7B engine stand', triangles: 103016, bytes: 885207 },
};

/** Do we have a model for this engine stand type? */
export function hasStandModel(standType) {
  return !!(standType && Object.prototype.hasOwnProperty.call(STAND_MODELS, standType));
}

/** Metadata for a model, or null. */
export function standModel(standType) {
  return hasStandModel(standType) ? STAND_MODELS[standType] : null;
}
